import { namespace } from 'vuex-class';
import { IDirectoryTreeState } from './directory-tree.types';

export const DirectoryTree = namespace('contentLibrary/directories/directoryTree');

export const state: IDirectoryTreeState = {
  loading: false,
  loaded: false,
  tree: {
    id: null,
    title: null,
    directory: null,
    children: [],
  },
  selected: null,
};

export enum EDirectoryTreeAction {
  LoadRoot = 'loadRoot',
  LoadRootSuccess = 'loadRootSuccess',
  LoadRootFailed = 'loadRootFailed',
  LoadSub = 'loadSub',
  LoadSubSuccess = 'loadSubSuccess',
  LoadSubFailed = 'loadSubFailed',
  Select = 'select',
  Reset = 'reset',
}

export enum EDirectoryTreeMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetDirectoryTree = 'setDirectoryTree',
  SetSelected = 'setSelected',
  SetState = 'setState',
}
